import { Typography } from "zudoku/components"
import { apiDescriptors } from "../../src/data/beyond-sandbox/api-info";
import { ProductApis } from "../components/product/ProductApis";

export const BeyondSandbox = () => (
    <>
        <Typography className="my-5 max-w-none">
            <h1>Beyond Sandbox APIs</h1>
            <p>Start testing your integration and data structure as you prepare to launch during the sandbox</p>
        </Typography>
        <ProductApis { ...{ apiDescriptors }} />
    </>
)
